module.exports = __webpack_public_path__ + "static/media/female.7e7b9b33.gif";